export enum ShippingOption {
  STANDARD = "STANDARD",
  SELF_PICK_UP = "SELF_PICK_UP",
  SPECIAL = "SPECIAL",
}
